import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchTranListApi } from "../../../apiservice/reports";
import {
  getBranchApi,
} from "../../../apiservice/setting";

// fetch main report
export const fetchBranchTransferList = createAsyncThunk(
  "branchTransferList/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        selectedFilterType: filters?.filterType || "All",
        fromBranchId: filters?.branchId || null,
        fromDate: filters?.fromDate || null,
        toDate: filters?.toDate || null,
      };
      const res = await getBranchTranListApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// branch lookup
export const fetchBranchesBySearch = createAsyncThunk(
  "branchTransferList/fetchBranches",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ query: search.trim() });
      return (res.data?.message || []).map((b) => ({
        sale_id: b.id,
        display_text: b.name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
